var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"lowercase",attrs:{"dark":""},on:{"click":_vm.downloadAttachment}},[_c('icon',{staticClass:"mr-2",attrs:{"icon":"cloud-download-alt"}}),_vm._v("Download ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }